export default {
  STORE_USER (state, user) {
    state.user = user
    state.userPending = false
  },
  STORE_PROMO_URL (state, promoUrl) {
    state.promoUrl = promoUrl
  },
  STORE_PROMO_WIDGET (state, promoWidget) {
    state.promoWidget = promoWidget
  },
  STORE_PROMO_MPC (state, mpcCode) {
    state.mpcCode = mpcCode
  },
  USER_PENDING (state, data) {
    state.userPending = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account/mutations.js